export { PageRoleGroupsFormComponent as PageRoleGroupsDetail } from './component';


// WEBPACK FOOTER //
// ./src/pages/role-groups-form/index.tsx